<div class="ibox-content">
  <form [formGroup]="form">
    <div class="form-group row">
      <mat-error *ngIf="MensajeError" class="eliminacionInvalida">{{MensajeError}}</mat-error>
      <mat-error *ngIf="MensajeRetro && !MensajeError && formHabilitado" class="eliminacionInvalida">{{MensajeRetro}}</mat-error>
    </div>
    <div class="row" hidden="true">
      <input formControlName="id" name="id" type="text" class="form-control" />
      <input formControlName="personal" name="personal" type="text" class="form-control" />
    </div>
    <div class="row panel panel-warning" *ngIf="!disabledEditing">
      <div class="col-lg">
        <label class="col-lg-3 col-form-label font-bold" for="desde">Desde</label>
        <div class="col-lg-8">
          <p-calendar appendTo="body" selectOtherMonths="true" formControlName="desde" dateFormat="dd/mm/yy" inputId="desde" ngDefaultControl (ngModelChange)="onChangeFechas()"></p-calendar>
          <div *ngIf="registerFormControl.desde.errors?.required && (registerFormControl.desde?.dirty || registerFormControl.desde?.touched)" class="text-danger">La Fecha es Requerida</div>
          <mat-error *ngIf="desdeAnterior && (registerFormControl.desde?.dirty || registerFormControl.desde?.touched || submitted)" class="text-danger">
            No puede ser anterior al ingreso {{ingreso.desde | date:'dd/MM/yyyy'}}
          </mat-error>
          <mat-error *ngIf="anteriorRetroactividad && (registerFormControl.desde?.dirty || registerFormControl.desde?.touched || submitted)" class="text-danger">
            No puede ser anterior al límite de retroactividad {{grupoLiq.periodoRetroactividadNavigation.fechaDd | date:'dd/MM/yyyy'}}
          </mat-error>
        </div>
      </div>
      <div class="col-lg">

        <label class="col-lg-3 col-form-label font-bold" for="hasta">Hasta</label>
        <div class="col-lg-8">
          <p-calendar appendTo="body" selectOtherMonths="true" formControlName="hasta" dateFormat="dd/mm/yy" inputId="hasta" ngDefaultControl (ngModelChange)="onChangeFechas()"></p-calendar>
          <div *ngIf="registerFormControl.hasta.errors?.required && (registerFormControl.hasta?.dirty || registerFormControl.hasta?.touched)" class="text-danger">La Fecha es Requerida</div>
          <mat-error  class="text-danger" *ngIf="registerFormControl.hasta.errors?.fecHastaMenor && (registerFormControl.hasta?.dirty || registerFormControl.hasta?.touched)">
            La Fecha no puede ser menor que la Fecha Desde
          </mat-error>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg">
        <label class="col-form-label font-bold">Parentezco</label>
        <div>
          <comboTools [list]=clasesFamiliarList
                      selected='claseFamilia'
                      [formParent]="form"
                      [isEditing]=disabledEditing
                      filter="descripcion"
                      ph='Clase de Familia'></comboTools>
          <div *ngIf="registerFormControl.claseFamilia.invalid && (registerFormControl.claseFamilia?.dirty || registerFormControl.claseFamilia?.touched || submitted)" class="text-danger">
            El Parentezco es Requerido
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg">
        <label class=" col-form-label font-bold">Nombre</label>
        <input formControlName="nombre" maxlength="50" name ="selectedNombre" type="text" class="form-control"  [ngClass]="{ 'is-invalid': registerFormControl.nombre.errors && (registerFormControl.nombre?.dirty || registerFormControl.nombre?.touched || submitted)}"/>
        <mat-error  class="text-danger"*ngIf="registerFormControl.nombre.errors?.required && (registerFormControl.nombre?.dirty || registerFormControl.nombre?.touched || submitted)">
            El Nombre es Requerido
        </mat-error>
      </div>
      <div class="col-lg">
        <label class=" col-form-label font-bold">Apellido</label>
        <input formControlName="apellido" maxlength="50" name ="selectedApellido" type="text" class="form-control"  [ngClass]="{ 'is-invalid': registerFormControl.apellido.errors && (registerFormControl.apellido?.dirty || registerFormControl.apellido?.touched || submitted)}"/>
        <mat-error  class="text-danger"*ngIf="registerFormControl.apellido.errors?.required && (registerFormControl.apellido?.dirty || registerFormControl.apellido?.touched || submitted)">
            El Apellido es Requerido
        </mat-error>
      </div>
    </div>
    <div class="row">
      <div class="col-lg">
        <label class=" col-form-label font-bold">Segundo Apellido</label>
        <input formControlName="segundoApellido" maxlength="50" name ="selectedSegundoApellido" type="text" class="form-control" [ngClass]="{ 'is-invalid': registerFormControl.segundoApellido.errors && (registerFormControl.segundoApellido?.dirty || registerFormControl.segundoApellido?.touched || submitted)}"/>
      </div>
      <div class="col-lg">
        <label class="col-form-label font-bold">Sexo</label>
        <div>
          <comboTools [list]=sexosList
                      selected='sexo'
                      [formParent]="form"
                      [isEditing]=disabledEditing
                      filter="descripcion"
                      ph='Sexo'></comboTools>
          <div *ngIf="registerFormControl.sexo.invalid && (registerFormControl.sexo?.dirty || registerFormControl.sexo?.touched || submitted)" class="text-danger">
            Sexo es Requerido
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg">
        <label class="col-form-label font-bold">Clase Documento</label>
        <div>
          <comboTools [list]=clasesDocList
                      selected='claseDocumento'
                      [formParent]="form"
                      [isEditing]=disabledEditing
                      filter="descripcion"
                      ph='Clase de Documento'></comboTools>
          <div *ngIf="registerFormControl.claseDocumento.invalid && (registerFormControl.claseDocumento?.dirty || registerFormControl.claseDocumento?.touched || submitted)" class="text-danger">
            La Clase Documento es Requerida
          </div>
        </div>
      </div>
      <div class="col-lg">
        <label class=" col-form-label font-bold">Nro. Documento</label>
        <input formControlName="docNro" name ="selectedDocNro" type="text" class="form-control"  [ngClass]="{ 'is-invalid': registerFormControl.docNro.errors && (registerFormControl.docNro?.dirty || registerFormControl.docNro?.touched || submitted)}"/>
        <mat-error  class="text-danger"*ngIf="registerFormControl.docNro.errors?.required && (registerFormControl.docNro?.dirty || registerFormControl.docNro?.touched || submitted)">
            El Nro. Documento es Requerido
        </mat-error>
      </div>
    </div>
    <div class="row">
      <div class="col-lg">
        <label class="col-form-label font-bold" for="desde">Fecha Nacimiento</label>
        <div>
          <p-calendar appendTo="body" selectOtherMonths="true" formControlName="fechaNacimiento" dateFormat="dd/mm/yy" inputId="fechaNacimiento" ngDefaultControl></p-calendar>
          <div *ngIf="registerFormControl.fechaNacimiento.errors?.required && (registerFormControl.fechaNacimiento?.dirty || registerFormControl.fechaNacimiento?.touched)" class="text-danger">La Fecha es Requerida</div>
          <mat-error *ngIf="nacimientoposterior && (registerFormControl.fechaNacimiento?.dirty || registerFormControl.fechaNacimiento?.touched || submitted)" class="text-danger">
            La Fecha no puede ser mayor que la Fecha Desde
          </mat-error>
        </div>
      </div>
      <div class="col-lg">
        <label class="col-form-label font-bold">Pais</label>
        <div>
          <comboTools [list]=paisesList
                      selected='pais'
                      [formParent]="form"
                      [isEditing]=disabledEditing
                      filter="descripcion"
                      ph='País'></comboTools>
          <div *ngIf="registerFormControl.pais.invalid && (
               registerFormControl.pais?.dirty || registerFormControl.pais?.touched || submitted)" class="text-danger">
            EL País es Requerido
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg">
        <label class="col-form-label font-bold">Nacionalidad</label>
        <div>
          <comboTools [list]=nacionalidadesList
                      selected='nacionalidad'
                      [formParent]="form"
                      [isEditing]=disabledEditing
                      filter="descripcion"
                      ph='Nacionalidad'></comboTools>
          <div *ngIf="registerFormControl.nacionalidad.invalid && (registerFormControl.nacionalidad?.dirty || registerFormControl.nacionalidad?.touched || submitted)" class="text-danger">
            La Nacionalidad es Requerida
          </div>
        </div>
      </div>
      <div class="col-lg">
        <label class="col-form-label font-bold">Estado Civil</label>
        <div>
          <comboTools [list]=estadoCivilList
                      selected='estadoCivil'
                      [formParent]="form"
                      [isEditing]=disabledEditing
                      filter="descripcion"
                      ph='Estado Civil'></comboTools>
          <div *ngIf="registerFormControl.estadoCivil.invalid && (registerFormControl.estadoCivil?.dirty || registerFormControl.estadoCivil?.touched || submitted)" class="text-danger">
            EL Estado Civil es Requerido
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg">
        <label class=" col-form-label font-bold">Celular</label>
        <input formControlName="celular" maxlength="50" name ="selectedCelular" type="text" class="form-control"  [ngClass]="{ 'is-invalid': registerFormControl.celular.errors && (registerFormControl.celular?.dirty || registerFormControl.celular?.touched || submitted)}"/>
        <mat-error  class="text-danger"*ngIf="registerFormControl.celular.errors?.required && (registerFormControl.celular?.dirty || registerFormControl.celular?.touched || submitted)">
            El Celular es Requerido
        </mat-error>
      </div>
      <div class="col-lg">
        <label class=" col-form-label font-bold">Email</label>
        <input formControlName="email" maxlength="50" name ="selectedEmail" type="text" class="form-control"  [ngClass]="{ 'is-invalid': registerFormControl.email.errors && (registerFormControl.email?.dirty || registerFormControl.email?.touched || submitted)}"/>
        <mat-error  class="text-danger"*ngIf="registerFormControl.email.errors?.required && (registerFormControl.email?.dirty || registerFormControl.email?.touched || submitted)">
            El Email es Requerido
        </mat-error>
      </div>
    </div>
    <br>
    <div class="row">
      <div class="col-lg">
        <p-checkbox formControlName="discapacitado" binary="true" label="Discapacitado" (onChange)="cambioDiscapacitado($event)"></p-checkbox>
      </div>
      <div class="col-lg">
        <p-checkbox formControlName="contactoEmergencia" binary="true" label="Contacto de Emergencia"></p-checkbox>
      </div>
    </div>
    <div class="row">
      <div class="col-lg" *ngIf="registerFormControl.discapacitado.value===true">
        <label class="col-form-label font-bold" for="desde">Presentación Certificado</label>
        <div>
          <p-calendar appendTo="body" [defaultDate]="null" selectOtherMonths="true" formControlName="presentacionCertificado" dateFormat="dd/mm/yy" inputId="presentacionCertificado" ngDefaultControl></p-calendar>
          <div *ngIf="registerFormControl.presentacionCertificado.errors?.required && (registerFormControl.presentacionCertificado?.dirty || registerFormControl.presentacionCertificado?.touched)" class="text-danger">La Fecha es Requerida</div>
        </div>
      </div>
      <div class="col-lg"></div>
    </div>
  </form>
</div>

